<template>
  <div class="box">
    <div class="head-box">
      <b>通知公告</b> Notice
    </div>
    <div v-if="data.length > 0" style="width:1200px;overflow: hidden;margin-bottom:20px;">
      <div v-for="(item, index) in data" :key="index" @click="lookContent(item)" style="margin-top:20px;overflow: hidden;border: 1px dashed #ccc;height:40px;line-height:40px;">
        <h3>&ensp;{{ index + 1 }}.{{ item.title }}</h3>
      </div>
    </div>
    <a-modal width="800px" v-model="visible" title="公告内容" :footer="null">
      <div v-html="content"></div>
    </a-modal>
  </div>
</template>

<script>
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'ExaminSchedule',
  components: {
    Upload
  },
  data () {
    return {
      matchFun,
      data: [],
      visible: false,
      content: ''
    }
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.examin.examinNoticeList({pointId: this.$route.query.id}).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    lookContent (item) {
      this.visible = true
      this.content = item.content
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 1200px;
  margin: 0 auto;
}
.head-box{
  font-size: 18px;
  color: black;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid rgb(235, 234, 234);
}
.table-header{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #244e8f;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
}
.table-body{
    width: 100%;
    line-height: 50px;
    // background: #B01F24;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.header-list{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color:white;
}
.flx-1{
    flex: 1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
    border-right:1px solid #ccc;
    border-bottom:1px solid #ccc;
    height: 50px;
}
.body-list{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/ActivityNotice.vue